// src/components/CourseDataComponent.jsx
import React from "react";
import { Link } from "react-router-dom";
import { MonoButton } from "../kits";

const CourseDataComponent = ({ courses = [], onDelete, onEdit, onToggleFavorite }) => {
  if (!Array.isArray(courses)) {
    console.warn("courses ist kein Array:", courses);
    return <p>Fehler beim Laden der Kursdaten.</p>;
  }

  return (
    <div className="mb-10">
      <h2 className="text-sm text-brand font-bold mb-4">Kursverwaltung</h2>
   
      <span className="space-x-4">


              <Link to ="/professioneditor">
<MonoButton className="text-xs" >
  Profession erstellen 
</MonoButton>
</Link>
        <Link to="/course/new/">
        <MonoButton className="text-xs">
          Kurs erstellen
        </MonoButton>
      </Link>


    
  <Link to="/skillmanager">
  <MonoButton className="text-xs">
   Skill Manager
  </MonoButton>
</Link>

  <Link to="/prmanager">
  <MonoButton className="text-xs">
   Project Manager
  </MonoButton>
</Link>



</span>

      {courses.length === 0 ? (
        <p className="text-[#EFEBDC]0">Keine Kurse vorhanden.</p>
      ) : (
        <table className="table-auto w-full bg-white shadow-md rounded">
          <thead>
              <tr className="bg-black text-orange-50 text-xs  border rounded-lg">
              <th className="px-4 py-2 text-left">Titel</th>
              <th className="px-4 py-2 text-left">Kategorie</th>
              <th className="px-4 py-2 text-left">Favorit</th>
              <th className="px-4 py-2 text-left">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((course) => (
              <tr key={course.id} className="border-t text-xs">
                <td className="px-4 py-2">{course.title}</td>
                <td className="px-4 py-2">{course.icon}</td>
                <td     className={`px-3 py-1  w-auto rounded text-[#151515] ${
                      course.isFavorite === "1" || course.isFavorite === true ? "bg-brand text-center text-[#151515] rounded-sm w-auto" : ""
                    }`}>{course.isFavorite === "1" || course.isFavorite === true ? "Ja" : "Nein"}</td>
                <td className="px-3 py-2 space-x-2">
               
                  <button
                    onClick={() => onEdit(course.slug)}
                    className="px-3 py-1 text-xs bg-blue-600 text-slate-50 rounded"
                  >
                    Bearbeiten
                  </button>

                  <button
                    onClick={() => onDelete(course.id, course.slug)}  
                    className="px-3 py-1 text-xs bg-red-600 text-slate-50 rounded"
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CourseDataComponent;
